import script from "./loadMore.vue?vue&type=script&setup=true&lang=js"
export * from "./loadMore.vue?vue&type=script&setup=true&lang=js"

import "./loadMore.vue?vue&type=style&index=0&id=208bb10f&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-208bb10f"]])

export default __exports__